export default "__VITE_ASSET__Cc9EUFu0__"